function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null);

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M32.693,27.744L54.464,5.974c1.366-1.365,1.366-3.583,0-4.948c-1.367-1.367-3.583-1.367-4.95,0l-21.77,21.77 L5.975,1.025c-1.366-1.367-3.583-1.367-4.949,0c-1.367,1.365-1.367,3.583,0,4.948l21.77,21.771l-21.77,21.77 c-1.367,1.366-1.367,3.583,0,4.949c0.684,0.684,1.579,1.025,2.475,1.025s1.791-0.342,2.475-1.025l21.77-21.77l21.77,21.77 c0.683,0.684,1.579,1.025,2.475,1.025s1.791-0.342,2.476-1.025c1.366-1.366,1.366-3.583,0-4.949L32.693,27.744z"
});

var SvgErrore = function SvgErrore(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "-0.162 -0.142 56 56",
    enableBackground: "new -0.162 -0.142 56 56",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgErrore, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/errore.34974910.svg";
export { ForwardRef as ReactComponent };